// ====================================================
// src/components/block/liveStreamManagement/enchainements/ZoomEnchainement.tsx
//
// Le flux final grossit et s'estompe (comme repoussé vers l'avant), pendant
// que le preview part petit depuis le centre et grandit jusqu'à sa taille
// normale. Pas de réglage pour l'instant — même modèle que Fondu.
// ====================================================

import React from 'react';
import { Enchainement, EnchainementControlProps, EnchainementRenderInput } from './Enchainement';

export interface ZoomConfig {}

class ZoomEnchainementImpl extends Enchainement<ZoomConfig> {
  readonly id = 'zoom';
  readonly label = 'Zoom';
  readonly icon = 'ZoomIn';
  readonly defaultConfig: ZoomConfig = {};

  render(input: EnchainementRenderInput, _config: ZoomConfig): void {
    const { ctx, currentSource, currentRect, nextSource, nextRect, progress, width, height } = input;
    const cx = width / 2, cy = height / 2;

    // Sortant : grossit et s'estompe.
    ctx.save();
    ctx.globalAlpha = 1 - progress;
    const scaleOut = 1 + progress * 0.6;
    ctx.translate(cx, cy);
    ctx.scale(scaleOut, scaleOut);
    ctx.translate(-cx, -cy);
    ctx.drawImage(currentSource, currentRect.x, currentRect.y, currentRect.w, currentRect.h);
    ctx.restore();

    if (progress <= 0) return;

    // Entrant : part petit (40%), grandit jusqu'à sa taille normale.
    ctx.save();
    ctx.globalAlpha = progress;
    const scaleIn = 0.4 + progress * 0.6;
    ctx.translate(cx, cy);
    ctx.scale(scaleIn, scaleIn);
    ctx.translate(-cx, -cy);
    ctx.drawImage(nextSource, nextRect.x, nextRect.y, nextRect.w, nextRect.h);
    ctx.restore();
  }

  renderControls(_props: EnchainementControlProps<ZoomConfig>) {
    return null;
  }
}

export const zoomEnchainement = new ZoomEnchainementImpl();
